import { UPDATE_DEALER_CREDENTIALS, UPDATE_DEALER_CREDENTIALS_SUCCESSFUL, UPDATE_DEALER_CREDENTIALS_FAILED,RESET_ALERT} from "./actionTypes"

export const updateDealerCredentials = (data) => {
    return {
        type: UPDATE_DEALER_CREDENTIALS,
        payload: {data}
    }
}

export const updateDealerCredentialsSuccessful = (message) => {
    return {
        type: UPDATE_DEALER_CREDENTIALS_SUCCESSFUL,
        payload: {message}
    }
}

export const updateDealerCredentialsFailed = (error) => {
    return {
        type: UPDATE_DEALER_CREDENTIALS_FAILED,
        payload: error
    }
}

export const resetAlert = () => {
    return {
        type: RESET_ALERT,
    }
}